import { ArtistGroup, ArtistMember } from '@/types/photocard';
import { createContext, Dispatch, ReactNode, SetStateAction, useState } from 'react';

export interface IPhotocardContext {
  group: ArtistGroup;
  member: ArtistMember | null;
  setGroup: Dispatch<SetStateAction<ArtistGroup>>;
  setMember: Dispatch<SetStateAction<any>>;
}

const initialState = {
  group: {
    id: 5,
    name: '세븐틴',
    name_en: 'Seventeen',
    image: 'https://d1sut5kn3lwnf7.cloudfront.net/media/group/2022/08/02/835c94ebb9b34612b8bd8a3ec7d586d4.jpg'
  },
  member: {
    id: 50,
    name: '에스쿱스',
    name_en: 'S.COUPS',
    image: 'https://d1sut5kn3lwnf7.cloudfront.net/media/member/2022/03/16/2a16b5d8913943159f317f94eb17faae.jpg'
  },
  setGroup: () => {},
  setMember: () => {}
};

export const PhotocardsContext = createContext<IPhotocardContext>(initialState);

export const PhotocardsProvider = ({ children }: { children: ReactNode }) => {
  const [group, setGroup] = useState<ArtistGroup>(initialState.group);
  const [member, setMember] = useState<ArtistMember>(initialState.member);
  return <PhotocardsContext.Provider value={{ group, member, setGroup, setMember }}>{children}</PhotocardsContext.Provider>;
};
